module.exports = __webpack_public_path__ + "img/camp_shirt_gk3.aeaf167b.svg";